// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { AddressDoc, MachineModel, MachineRef, MachineUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MachineActions {
  export class GetAllMachine {
    static readonly type = '[Machine] GetAllMachine';
    readonly type = GetAllMachine.type;
  }

  export class InitMachines {
    static readonly type = '[Machine] InitMachines';

    constructor(public id?: string) {}
  }

  export class CloseMachinesConnection {
    static readonly type = '[Machine] CloseMachinesConnection';
    readonly type = CloseMachinesConnection.type;
  }

  export class GetMachineById {
    static readonly type = '[Machine] GetMachineById';
    readonly type = GetMachineById.type;
  }

  export class UpdateMachine {
    static readonly type = '[Machine] UpdateMachine';
    constructor(
      public machineData: Partial<MachineUpdateData>,
      public ref: MachineRef,
    ) {}
  }

  export class UpdateMachineResult {
    static readonly type = '[Machine] UpdateMachineResult';
    constructor(public data: Array<TypesaurusCoreDoc<MachineModel> | null | undefined>) {}
  }

  export class DeleteMachine {
    static readonly type = '[Machine] DeleteMachine';
    constructor(public refs: MachineRef[]) {}
  }

  export class QueryMachine {
    static readonly type = '[Machine] QueryMachine';

    constructor(
      public filter: {
        query: AbstractQueryParams<MachineModel>[];
      },
    ) {}
  }
  export class SetSelectedAddress {
    static readonly type = '[Machine] SetSelectedAddress';

    constructor(public selectedAddress: AddressDoc) {}
  }
  export class MachineError {
    static readonly type = '[Machine] MachineError';

    constructor(public error: Error) {}
  }
}
